import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  { path: '/',              label: 'Dashboard' },
  { path: '/users',         label: 'Users' },
  { path: '/subscriptions', label: 'Subscriptions' },
  { path: '/analytics',     label: 'Analytics' },
  { path: '/content',       label: 'Content & Exams' },
  { path: '/llm-config',    label: 'LLM Config' },
  { path: '/system',        label: 'System Health' },
  { path: '/config',            label: 'Configuration' },
  { path: '/subject-requests',  label: 'Subject Requests' },
  { path: '/courses',           label: 'Courses' },
  { path: '/blog',              label: 'Blog' },
];

export default function Sidebar() {
  return (
    <aside className="w-60 min-h-screen bg-admin-sidebar flex flex-col">
      <div className="px-6 py-5 border-b border-slate-700">
        <span className="text-white font-semibold text-lg tracking-tight">Aria Tutor Admin</span>
      </div>
      <nav className="flex-1 py-4 px-3 space-y-1">
        {NAV_ITEMS.map(({ path, label }) => (
          <NavLink
            key={path}
            to={path}
            end={path === '/'}
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-admin-accent text-white'
                  : 'text-slate-300 hover:bg-admin-sidebar-hover hover:text-white'
              }`
            }
          >
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
